import React, { useEffect, useRef, useState } from 'react';
import { FormFeedback, Input, Label } from 'reactstrap';
import DefaultAppLogo from '../../../../assets/images/lystfacelogos/DefaultAppLogo.svg'
import ProfileImageIcon from '../../../../assets/images/lystfacelogos/ProfileImageIcon.svg'
import { imageValidation } from '../../../../config';
import { useSelector } from 'react-redux';
import { DeleteIcon, EditIcon } from '../../../../components/Common/SvgIcons';
import RightSideModal from '../../../../components/Common/RightSideModal';
import ProfileUpdate from '../../../Dashboard/application/ProfileUpdate';

const Content = ({ applicationStatus, validationType, handlePhotoUplaod, profileIcon, handleDeleteIcon, fileInputKey, setFileInputKey, isremoved, croppedImage, setCroppedImage, validationMessage, setValidationMessage }) => {
    const { allowedFormats } = imageValidation
    const formatsList = allowedFormats.map((format) => `${format}`).join(",")
    const { userName: username } = useSelector(state => state.Login.constDetails)
    const [popupDetails, setPopupDetails] = useState({ open: false })
    const cropperRef = useRef(null);
    const [isDisabled, setIsDisabled] = useState(false);




    useEffect(() => {
        if (croppedImage && validationType.values.cropIcon) {
            validationType.setFieldValue("user_icon", validationType.values.cropIcon)


        }
    }, [croppedImage])

    function base64ToFile(base64String, fileName) {
        const arr = base64String.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], fileName, { type: mime });
    }

    const handleClickPrimaryButton = (validationType) => {

        if (cropperRef.current) {
            let imageURL = cropperRef?.current?.src
            if (!imageURL.startsWith('https')) {
                const croppedCanvas = cropperRef.current.cropper.getCroppedCanvas();
                const croppedFile = base64ToFile(croppedCanvas.toDataURL(), 'cropped_image.png');
                validationType.setFieldValue("user_icon_file", croppedFile)
                setCroppedImage(croppedCanvas.toDataURL());
            }

        }
        else {
            handleDeleteIcon();
            setCroppedImage(null)


        }
        setPopupDetails({ open: false })

    }

    const handleClickSecondaryButton = () => {
        setPopupDetails({ open: false })
        validationType.setFieldValue("cropIcon", "")
        validationType.setFieldValue("user_icon_file", "")
        setFileInputKey(Date.now());



    }

    const handleEditIcon = () => {
        setPopupDetails({
            open: true, titleText: `${(croppedImage || profileIcon) ? 'Edit Image' : 'Add Image'}`, title: validationType, bodyText: 'You have unsaved changes in this page. Are you sure you want to discard?', primaryButtonText: 'Save', secondaryButtonText: 'Cancel', handleClickSecondaryButton: handleClickSecondaryButton, handleClickPrimaryButton: handleClickPrimaryButton, handleClose: handleClickSecondaryButton
        })
    }


    const handleBrowseFiles = (from) => {
        document.getElementById("profile-upload").click()
    }

    return (
        <>
            <Label htmlFor="profile-picture" className={`${applicationStatus !== "manage" ? "custom-file-upload" : "manage-file-upload"}`}>
                <div className={`${(!croppedImage && !profileIcon) ? applicationStatus !== "manage" ? "account-profile-name-edit-view" : "account-profile-name" : "img-wrap"}`}>
                    {(!croppedImage && !profileIcon) ?
                        <>
                            <span >{validationType?.values ? validationType?.values?.firstName?.charAt(0).toUpperCase() : username.charAt(0).toUpperCase()}</span>
                            <div class="profile-hover-overlay" onClick={handleEditIcon}>
                                <div className="profile-action">
                                    {(croppedImage || profileIcon) ? "Edit" : "Add"}
                                </div>
                            </div>

                        </>
                        :
                        <>
                            <img
                                className={`profile-img ${applicationStatus !== "manage" ? croppedImage || profileIcon ? "" : "image-placeholder" : ""}`}
                                for="profile-upload"
                                src={croppedImage ? croppedImage : profileIcon ? profileIcon : ProfileImageIcon}


                            />
                            <div class="profile-hover-overlay" onClick={handleEditIcon}>
                                <div className="profile-action">
                                    {(croppedImage || profileIcon) ? "Edit" : "Add"}
                                </div>
                            </div>
                        </>
                    }

                </div>
                {applicationStatus !== "manage" &&
                    <Input
                        id="profile-upload"
                        type="file"
                        onChange=
                        {(e) => handlePhotoUplaod(e)}
                        onBlur={validationType.handleBlur}
                        accept={formatsList}
                        readOnly={applicationStatus === "manage" ? true : false}
                        key={fileInputKey}
                    />}
            </Label>
            {applicationStatus !== "manage" && validationType.touched.user_icon && validationType.errors.user_icon ? (
                <FormFeedback type="invalid" className="d-block">
                    {validationType.errors.user_icon}
                </FormFeedback>
            ) : null}

            <div className="app-form-fields-container-setting">
                <div className="form-input-container">

                    <Label className={`${applicationStatus === "manage" ? "form-manage-title" : "form-input-title"}`}>
                        First name <span className="text-danger"> *</span>
                    </Label>

                    <Input
                        name="firstName"
                        className={`${applicationStatus === "manage" ? "form-manage-input" : "form-input"}
                         ${validationType.touched.firstName && validationType.errors.firstName
                                ? `border-danger`
                                : ``
                            }
                             `}
                        formNoValidate={true}
                        type="text"
                        onChange={(e) => {
                            e.target.value = e.target.value;
                            validationType.handleChange(e);
                        }}

                        onBlur={validationType.handleBlur}
                        value={validationType.values.firstName?.trimStart() || ""}
                        readOnly={applicationStatus === "manage" ? true : false}
                        disabled={applicationStatus === "manage" ? true : false}
                        autoComplete='off'
                    />
                    {applicationStatus !== "manage" && validationType.touched.firstName && validationType.errors.firstName ? (
                        <FormFeedback type="invalid" className="d-block">
                            {validationType.errors.firstName}
                        </FormFeedback>
                    ) : null}

                </div>
                <div className="form-input-container">

                    <Label className={`${applicationStatus === "manage" ? "form-manage-title" : "form-input-title"}`}>
                        Last name
                    </Label>

                    <Input
                        name="lastName"
                        className={`${applicationStatus === "manage" ? "form-manage-input" : "form-input"}
                        ${validationType.touched.lastName && validationType.errors.lastName
                                ? `border-danger`
                                : ``
                            }
                            `}
                        formNoValidate={true}
                        type="text"
                        onChange={(e) => {
                            e.target.value = e.target.value;
                            validationType.handleChange(e);
                        }} onBlur={validationType.handleBlur}
                        value={validationType.values.lastName ? validationType.values.lastName?.trimStart() : applicationStatus === "manage" ? "-" : ""}
                        readOnly={applicationStatus === "manage" ? true : false}
                        disabled={applicationStatus === "manage" ? true : false}
                        autoComplete='off'
                    />
                    {applicationStatus !== "manage" && validationType.touched.lastName && validationType.errors.lastName ? (
                        <FormFeedback type="invalid" className="d-block">
                            {validationType.errors.lastName}
                        </FormFeedback>
                    ) : null}

                </div>
            </div>
            <div className="app-form-fields-container-setting">
                <div className="form-input-container">

                    <Label className={`${applicationStatus === "manage" ? "form-manage-title" : "form-input-title"}`}>
                        Company name <span className="text-danger"> *</span>
                    </Label>

                    <Input
                        name="company"
                        className={`${applicationStatus === "manage" ? "form-manage-input" : "form-input"}
                        ${validationType.touched.company && validationType.errors.company
                                ? `border-danger`
                                : ``
                            }
                            `}
                        formNoValidate={true}
                        type="text"
                        onChange={(e) => {
                            e.target.value = e.target.value;
                            validationType.handleChange(e);
                        }} onBlur={validationType.handleBlur}
                        value={validationType.values.company?.trimStart() || ""}
                        readOnly={applicationStatus === "manage" ? true : false}
                        disabled={applicationStatus === "manage" ? true : false}
                        autoComplete='off'
                    />
                    {applicationStatus !== "manage" && validationType.touched.company && validationType.errors.company ? (
                        <FormFeedback type="invalid" className="d-block">
                            {validationType.errors.company}
                        </FormFeedback>
                    ) : null}

                </div>
                <div className="form-input-container">

                    <Label className={`${applicationStatus === "manage" ? "form-manage-title" : "form-input-title"}`}>
                        Role <span className="text-danger"> *</span>
                    </Label>

                    <Input
                        name="role"
                        className={`${applicationStatus === "manage" ? "form-manage-input" : "form-input disabled"}
    ${validationType.touched.role && validationType.errors.role
                                ? `border-danger`
                                : ``
                            }
        `}
                        formNoValidate={true}
                        type="text"
                        onChange={(e) => {
                            e.target.value = e.target.value;
                            validationType.handleChange(e);
                        }} onBlur={validationType.handleBlur}
                        value={validationType.values.role || applicationStatus === "manage" && '-' || ""}
                        readOnly={applicationStatus === "manage" ? true : true}
                        disabled={applicationStatus === "manage" ? true : true}
                        autoComplete='off'
                    />
                    {applicationStatus !== "manage" && validationType.touched.role && validationType.errors.role ? (
                        <FormFeedback type="invalid" className="d-block">
                            {validationType.errors.role}
                        </FormFeedback>
                    ) : null}

                </div>

            </div>
            {
                popupDetails.open &&
                <RightSideModal
                    popupDetails={popupDetails}
                    primaryButtonDisabled={isDisabled}

                >
                    <ProfileUpdate handleEditClick={handleBrowseFiles} handlePhotoUplaod={handlePhotoUplaod} image={validationType?.values?.cropIcon ? validationType?.values?.cropIcon : validationType?.values?.user_icon ? validationType?.values?.user_icon : profileIcon ? profileIcon : null} cropperRef={cropperRef} handleDeleteClick={handleDeleteIcon} validationType={validationType} setFileInputKey={setFileInputKey} isremoved={isremoved} isCdnImage={(validationType?.values?.cropIcon || validationType?.values?.user_icon) ? false : true} updatedImage={validationType?.values?.user_icon ? validationType?.values?.user_icon : profileIcon ? profileIcon : null} setIsDisabled={setIsDisabled} croppedImage={croppedImage} validationMessage={validationMessage} setValidationMessage={setValidationMessage} />
                </RightSideModal>
            }
        </>
    )
}

export default Content;